import { render, staticRenderFns } from "./events-details.vue?vue&type=template&id=08673e96"
import script from "./events-details.vue?vue&type=script&lang=js"
export * from "./events-details.vue?vue&type=script&lang=js"
import style0 from "./events-details.vue?vue&type=style&index=0&id=08673e96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports